export const DepthSize = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M9.96289 16L9.96289 4M9.96289 16L6.96289 14M9.96289 16L12.9629 14M9.96289 4L6.96289 6M9.96289 4L12.9629 6M14.9629 1H4.96289M18.9629 19H0.962891M18.2962 16L15.4479 3.18237M4.47792 3.18237L1.62956 16"
                stroke="#838280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}